/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const GET_USER_NOTIFICATION_SUBSCRIPTIONS = gql`
  query GetUserNotificationSubscriptions {
    userNotificationSubscriptions {
      id
      channels
      rule {
        id
        name
        targetId
        targetType
        triggerCondition
      }
    }
  }
`
